export const CALENDAR_CHANGE_REASON: Record<string, string> = {
  manualInput: 'manual input',
  dropdownClick: 'dropdown click',
  dropdownKeyboard: 'dropdown keyboard',
  okClick: 'ok click',
  cancelClick: 'cancel click',
  okKeyboard: 'ok keyboard',
  cancelKeyboard: 'cancel keyboard',
} as const;
